import React, { createContext, useContext } from 'react'

interface UserContextType {
  profile: null
  isLoading: boolean
  error: Error | null
  refetch: () => void
}

const UserContext = createContext<UserContextType | undefined>(undefined)

export function UserProvider({ children }: { children: React.ReactNode }) {
  // No authentication - return mock data
  const value: UserContextType = {
    profile: null,
    isLoading: false,
    error: null,
    refetch: () => {}
  }
  
  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  )
}

export function useUserProfile() {
  const context = useContext(UserContext)
  if (context === undefined) {
    throw new Error('useUserProfile must be used within a UserProvider')
  }
  return context
}